export default  {
    lineStatus: 'status',
    subtotal: 'subtotal',
    buyNum: 'quantity',
    foregift: 'cash pledge',
    unitPrice: 'unit price',
    specifications: 'specifications',
    goodsName: 'product name ',
    order_type: 'Order type',
    Remittance_id: 'Remittance id',
    download_btn: 'Download rental list',
    cancel: 'Cancel',
    notes_tishi: 'Fill in the schematic diagram of remittance application form: in order to successfully complete offline remittance, please correctly fill in the remittance identification code in the column of remittance purpose',
    notes_six: 'Online pre-lease will not send you SMS messages or links in the name of invalid orders, abnormal orders, system upgrades, etc., requiring you to provide your bank card and verification code information. Please strengthen your awareness of prevention, and beware of fraud.',
    notes_five: 'If the website order is not updated to the "paid" status within 5 working days after the remittance, please contact us. If the "paid" status is not showed within specified period and we are not informed, the order will be regarded as invalid order and our company will not be responsible for that.',
    notes_four: 'The amount of remittance should be consistent with the amount payable.',
    notes_three: 'While making remittance, please fill in the following remittance identification code into the remittance slip.',
    notes_two: 'Please wait for confirmation of receipt after remittance. It costs generally 1-3 working days.',
    notes_one_floot: ' Please remit the payment as soon as possible, because the overdue order will be cancelled automatically.',
    notes_one_header: 'Please remit the pending payment to the above designated account through the bank before ',
    need_attention_text: 'Notes: ',
    bank_account: 'Bank',
    unit_opener: 'account-opening unit',
    bank_deposit: 'Beneficiary',
    remittance_title: 'Designated account for offline remittance',
    unpaid: 'UNPAID',
    pendding: 'PENDING',
    verified: 'VERIFIED',
    rejected: 'REJECTED',
    refunding: 'REFUNDING',
    refunded: 'REFUNDED',
    cancelled:' CANCELED',
    completed: 'COMPLETED',
    submitted: 'SUBMITTED',
    paid: 'PAID',
    cancell: 'CANCELED',
    disbaled: 'DISABLED',
    penddingPay: 'PENDING_PAY',

    finish: 'FINISH',
    online: 'E-currency payment',
    cash: 'Cash',
    balance: 'Balance',
    wire: 'Offline remittance',
    miniapps: 'miniApps WeChat payment',
    wechat: 'WeChat payment',
    alipay: 'Alipay payment',
    wechat_scan: 'WeChat scan code payment',
    alipay_scan: 'Alipay scan code payment',
    wechat_h5: ' WeChat, H5 payment',
    info_tip: 'Info',
    info_content: 'Are you sure to cancel order? click "OK" will cancel order, it cannot be undone',
    info_continue_content: 'Are you sure continue to pay order? '
  }



// WEBPACK FOOTER //
// ./src/i18n/en-us/order_info.js